<template>
  <div style="position: relative" class="pt-5">
    <Alert />
    <div class="row h-75" style="position: relative">
      <div class="col-md-2 d-flex justify-content-center align-items-center">
        <Stepper :finalizado="true" />
      </div>
      <div class="col-md-3 d-flex justify-content-center mt-5">
        <div class="letters">
          <div class="first-letter">
            <span>PA</span><br />
            <img src="../assets/images/form.png" />
          </div>
          <span>RA</span><br />
          <span>BENS!</span>
        </div>
      </div>
      <div class="col-md-7 d-flex justify-content-end mt-4 pr-5">
        <div>
          <div class="d-flex justify-content-center">
            <img style="width: 250px" src="https://i.imgur.com/LvoKWMb.png" />
          </div>
          <div class="card">
            <span>PLANO ADQUIRIDO</span>
            <div class="plano d-flex justify-content-between">
              <span>{{ item.nome }}</span>
              <span>-</span>
              <span>R$ {{ item.valor_a_prazo }}</span>
            </div>
            <hr />
          </div>
          <hr />
        </div>

        <div class="card">
          <span>VERIFIQUE SEU E-MAIL PARA MAIORES INFORMAÇÕES</span>
          <button @click="$router.push({ path: '/' })" class="btn-card">
            COMEÇAR A JOGAR
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Stepper from "../components/Stepper";
import Alert from "../components/AlertaPlano";
import firebase from 'firebase';

export default {
    name: 'Finalizado',
    components:{
        Stepper,
        Alert
    },
    data: () => ({
        item: {}
    }),
    created: function(){
        this.analyticSubmit();
    },
    mounted: async function(){
        this.item = this.$store.getters.getItemInCart.payload
        localStorage.removeItem("abriuPagamento"); 
    },
    methods: {
        analyticSubmit(){
            try {
                //firebase.analytics().setCurrentScreen("WEB_tela_finalizado");
                firebase.analytics().logEvent("WEB_tela_finalizado", {
                    product_id: this.item.id, 
                    price: this.item.valor_a_prazo, 
                    name: this.item.nome,
                });
            } catch (error) {
                console.log("analytic finalizado error:", error)
            }
            try {
                this.$intercom.trackEvent("WEB_tela_finalizado");
            } catch (error) {
                console.log("analyticIntercom finalizado error:", error)
            }
        }
    }
}
</script>
<style scoped>
.letters {
  font-size: 70px !important;
  line-height: 80px;
  letter-spacing: 4px;
}

.first-letter {
  position: relative;
}

.plano span {
  font-family: "Agency FB Regular" !important;
  letter-spacing: 2px !important;
  font-size: 12px !important;
  padding: 0px 10px;
  opacity: 0.5;
}

.card {
  border: none;
  padding: 15px 30px;
  box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  margin: 10px 0px;
  font-size: 14px !important;
  position: relative;
}

.card span {
  font-size: 14px;
  letter-spacing: 1px;
}

.card .btn-card {
  position: absolute;
  width: 100%;
  left: 0;
  height: 40px;
  bottom: -40px;
  background-color: #7b4e93;
  color: white;
  border: none;
  outline: 0;
}

.first-letter img {
  position: absolute;
  width: 35%;
  top: -15px;
  left: -25px;
  opacity: 0.5;
}
</style>